import React from "react";
import PropTypes from "prop-types";

function Heading({ heading, subHeading, border, className }) {
  return (
    <div
      className={`w-full pb-[5px] ${className} ${
        border === true ? "border-b-2 border-light" : ""
      }`}
    >
      <h4 className="text-lg font-semibold normal-case text-primary-dark">
        {heading}
      </h4>
      <p className="normal-case">{subHeading}</p>
    </div>
  );
}

Heading.propTypes = {
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  border: PropTypes.bool,
  className: PropTypes.string,
};

Heading.defaultProps = {
  border: false,
  className: "",
};

export default Heading;
